import { z } from 'zod';
import { csv } from './query.js';
// The territory grammar (ADR-037 §2 · ADR-080 §8) — the sites list's "Zone &
// cluster" filter: ONE key, `territory`, whose values carry their KIND —
// `zone:<id>` · `cluster:<id>` (the integer ids of the two tables, nine digits at
// most — inside the columns' range). Picks ADD UP: a site in ANY picked zone or
// ANY picked cluster. Only the HIGHEST pick is stored — the picker keeps a zone
// alone once it is ticked (its clusters read "Included"), so a cluster inside a
// picked zone never arrives beside it; the read expands a zone to its clusters
// when it runs. A kind the grammar does not know, or an id past nine digits, is
// a 400. The Location grammar (`common/location.ts`) is its sibling for the
// places a thing can sit at.
export const TERRITORY_KINDS = ['zone', 'cluster'];
/** One kinded value: `zone:<id>` or `cluster:<id>`. */
export const TerritoryTokenSchema = z
    .string()
    .max(24)
    .regex(/^(zone|cluster):[1-9]\d{0,8}$/, 'a territory is `zone:<id>` or `cluster:<id>`');
/** The `territory` query param — comma-separated tokens, at most 50 picks. */
export const TerritoryParamSchema = csv(TerritoryTokenSchema).pipe(z.array(z.string()).max(50, 'at most 50 territories').optional());
export function parseTerritory(tokens) {
    const out = { zoneIds: [], clusterIds: [] };
    for (const t of tokens ?? []) {
        const at = t.indexOf(':');
        const kind = t.slice(0, at);
        const id = Number(t.slice(at + 1));
        if (!Number.isInteger(id) || id <= 0)
            continue;
        const list = kind === 'zone' ? out.zoneIds : kind === 'cluster' ? out.clusterIds : null;
        if (list && !list.includes(id))
            list.push(id);
    }
    return out;
}
/** The token of one zone or cluster. */
export function territoryToken(kind, id) {
    return `${kind}:${id}`;
}
/** The tokens a link holds that the grammar accepts — a screen's TOLERANT read (ADR-037: a malformed or hand-edited
 *  value is dropped silently, never sent to fail the whole list); the server still refuses what it is handed. */
export function wellFormedTerritory(tokens) {
    return tokens.filter((t) => TerritoryTokenSchema.safeParse(t).success);
}
